<template>
  <div class="invert-cenarios">
    <b-modal
      id="ModalInvert"
      header-class="modal-cabecalho"
      :size="list.length == 3 ? 'lg' : ''"
      no-close-on-backdrop
      no-close-on-esc
    >
      <Header mini titulo="Inverter Cenários" icone="exchange-alt" cor="azul" slot="modal-header" />
      <div class="body-modal">
        <draggable
          class="list-group"
          tag="ul"
          v-model="list"
          v-bind="dragOptions"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group type="transition" name="flip-list">
            <li
              class="list-group"
              v-for="element in list"
              :key="element.order + '' + element.nomeCenario"
            >
              <div class="card-element">
                <div class="title-cenario">
                  <label v-b-tooltip.hover.top :title="element.nomeCenario">{{
                    simpleName(element.nomeCenario)
                  }}</label>
                </div>
                <div v-if="element.ncm" class="resume">
                  <b>NCM: </b>{{ element.ncm }}<br /><br />
                </div>
                <CardCenario :cenario="card(element)" />

                <div class="resume" v-html="showResume(element, getFiltros)" />
              </div>
            </li>
          </transition-group>
        </draggable>
      </div>

      <template slot="modal-footer">
        <BotaoPadrao
          arredondadoEsquerda
          class="botao-padding"
          nome="Cancelar"
          icone="times"
          :click="closeModal"
        />

        <BotaoPadrao
          arredondadoEsquerda
          class="botao-padding"
          nome="Confirmar"
          icone="check"
          :click="confirm"
          cor="azul"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import ModalSlot from "@/components/ModalSlot/ModalSlot.vue";
import Header from "@/components/ModalComponente/Header.vue";
import cenariosMixin from "@/mixins/cenariosMixin";
import CardCenario from "../../../components/CardCenario/CardCenario.vue";

export default {
  name: "InvertCenarios",
  mixins: [cenariosMixin],
  components: {
    ModalSlot,
    draggable,
    BotaoPadrao,
    CardCenario,
    Header
  },
  data() {
    return {
      labels: { title: "Inverter Cenários", message: "Arraste o cenário para inverter e confirme" },
      data: []
    };
  },
  computed: {
    ...mapGetters("cenario", ["getInvertCenarios", "getFiltros"]),
    list: {
      get() {
        return this.data.map((m, index) => {
          return { ...m, order: m.idCenario };
        });
      },
      set(newValue) {
        this.data = newValue;
      }
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    ...mapActions("cenario", [
      "setInvertCenarios",
      "setInvertCenariosConfirmed",
      "setLoadTemporaryCenarios",
      "setInvertCenariosConfirm",
      "deleteCenarioFalse"
    ]),
    ...mapActions("modal", ["setModalInvertCenarios"]),
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", "ModalInvert");
    },

    confirm: function() {
      const idsList = this.list.map(value => {
        return value.idCenario;
      });

      const lister = this.list.map((value, index) => {
        return { ...value, order: index + 1, idCenario: idsList[index] };
      });

      this.setInvertCenariosConfirmed(lister);
      this.$root.$emit("bv::hide::modal", "ModalInvert");
      this.setLoadTemporaryCenarios(true);

      this.$bus.$emit("carregaCenario", "1");
    },
    cancel: function() {
      this.setModalInvertCenarios(false);
    },
    simpleName: function(str) {
      str = str.length > 12 ? str.substring(0, 12) + "..." : str;

      return str.trim();
    },
    card(element) {
      let card = {
        nome_cenario: element.nomeCenario ? element.nomeCenario : false,
        id_local_operacao: element.tipoOperacao ? element.tipoOperacao : false,
        id_estado_origem: element.ufOrigem ? element.ufOrigem : false,
        id_estado_destino: element.ufDestino ? element.ufDestino : false,
        id_pais_origem: element.paisOrigem ? element.paisOrigem : false,
        id_pais_destino: element.paisDestino ? element.paisDestino : false,
        id_remetente_regime: element.regimeRemetente ? element.regimeRemetente : false,
        id_remetente_atividade: element.atividadeRemetente ? element.atividadeRemetente : false,
        id_remetente_tipo_atividade: element.tipoAtividadeRem ? element.tipoAtividadeRem : false,
        id_destinatario_regime: element.regimeDestinatario ? element.regimeDestinatario : false,
        id_destinatario_atividade: element.atividadeDestino ? element.atividadeDestino : false,
        id_destinatario_tipo_atividade: element.tipoAtividade ? element.tipoAtividade : false,
        id_origem: element.origem ? element.origem : false,
        id_destinacao: element.destinacao ? element.destinacao : false
      };
      return card;
    }
  },
  watch: {
    getInvertCenarios() {
      // if (newVal === true) {
      this.data = this.getInvertCenarios;
      // }
    }
  }
};
</script>

<style lang="scss">
.body-modal {
  display: flex;
  justify-content: center;
}
.title-cenario {
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  text-align: center;

  border-bottom: 1px var(--branco) solid;
  padding-bottom: 10px;
  margin-bottom: 10px;

  label {
    font-size: 18px;
    margin: 0;
    padding: 0;
  }
}

.container-card {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.resume {
  text-align: left;
  max-width: 150px;
  font-size: 11px;
}

.card-element {
  user-select: none;
  width: 200px;
  min-height: 100%;
  // max-height: 100%;
  box-shadow: var(--sombra1) 4px 4px;
  background: var(--azul4);
  color: var(--branco);
  text-align: center;
  padding: 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  transition: scale 0.3s ease-in-out, background 0.1s ease-in-out;
  &:hover {
    // text-decoration: none;
    // border: 1px #003356 solid;
    scale: 1.05;
    box-shadow: var(--sombra1) 4px 4px;
    background: var(--azul4);
  }
}

.invert-cenarios {
  ul.list-group span {
    display: flex !important;
    flex-direction: row !important;
  }

  .button {
    margin-top: 35px;
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: var(--preto);
  }
  .list-group {
    margin: 10px;
    min-height: 20px;
  }
  .list-group {
    cursor: move;
  }
  .list-group i {
    cursor: pointer;
  }
}
</style>
